import { array, option } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { Cashier, CashierAssignment, Profile } from '@mews-commander/data-access';
import { CashierWithAssignedProfiles } from './types';

export const getCashierNames = (
    cashierAssignments: CashierAssignment[],
    profiles: Record<string, Profile>,
    cashierId: string
) =>
    pipe(
        cashierAssignments,
        array.filterMap((it) => {
            const profile = profiles[it.profileId];
            return it.cashierId === cashierId
                ? option.some({
                      name: profile.name,
                      profileId: profile.id,
                  })
                : option.none;
        })
    );

export const transformCashiers = (cashierAssignments: CashierAssignment[], profiles: Record<string, Profile>) =>
    array.map(
        (cashier: Cashier): CashierWithAssignedProfiles => ({
            ...cashier,
            assignedProfiles: getCashierNames(cashierAssignments, profiles, cashier.id),
        })
    );
